import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "git-history-page" };
const _hoisted_2 = { class: "page-header" };
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = {
    key: 0,
    class: "data-section token-gate"
};
const _hoisted_5 = { class: "token-row" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    key: 0,
    class: "error-text"
};
const _hoisted_8 = { class: "toolbar" };
const _hoisted_9 = { class: "control-group" };
const _hoisted_10 = { class: "control-group" };
const _hoisted_11 = { class: "presets" };
const _hoisted_12 = {
    key: 0,
    class: "loading"
};
const _hoisted_13 = {
    key: 1,
    class: "error-text"
};
const _hoisted_14 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_15 = {
    key: 0,
    class: "warning-text"
};
const _hoisted_16 = { class: "summary-cards" };
const _hoisted_17 = { class: "summary-card" };
const _hoisted_18 = { class: "summary-value" };
const _hoisted_19 = { class: "summary-card" };
const _hoisted_20 = { class: "summary-value" };
const _hoisted_21 = { class: "summary-card" };
const _hoisted_22 = { class: "summary-value" };
const _hoisted_23 = { class: "data-section" };
const _hoisted_24 = { class: "summary-head" };
const _hoisted_25 = { class: "summary-actions" };
const _hoisted_26 = { class: "auto-refresh" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = { class: "subtitle" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { class: "heatmap-label" };
const _hoisted_31 = {
    key: 0,
    class: "empty-state"
};
const _hoisted_32 = {
    key: 1,
    class: "run-list"
};
const _hoisted_33 = { class: "run-name" };
const _hoisted_34 = ["href"];
const _hoisted_35 = { class: "run-time" };
const _hoisted_36 = ["href"];
const _hoisted_37 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_38 = {
    key: 3,
    class: "run-list"
};
const _hoisted_39 = { class: "run-name" };
const _hoisted_40 = ["href"];
const _hoisted_41 = { class: "run-time" };
const _hoisted_42 = ["href"];
const _hoisted_43 = { class: "data-section" };
const _hoisted_44 = { class: "summary-head" };
const _hoisted_45 = { class: "summary-actions" };
const _hoisted_46 = ["disabled"];
const _hoisted_47 = { class: "summary-controls" };
const _hoisted_48 = { class: "control-group branch-group" };
const _hoisted_49 = ["value"];
const _hoisted_50 = { class: "subtitle" };
const _hoisted_51 = {
    key: 0,
    class: "error-text"
};
const _hoisted_52 = {
    key: 1,
    class: "loading"
};
const _hoisted_53 = {
    key: 2,
    class: "summary-output"
};
const _hoisted_54 = { class: "data-section" };
const _hoisted_55 = { class: "data-section" };
const _hoisted_56 = { class: "heatmap-label" };
const _hoisted_57 = { class: "heatmap-label" };
const _hoisted_58 = { class: "heatmap-label" };
const _hoisted_59 = { class: "data-section" };
const _hoisted_60 = { class: "table-wrapper" };
const _hoisted_61 = { class: "detail-table" };
const _hoisted_62 = { class: "data-section" };
const _hoisted_63 = { class: "search-box" };
const _hoisted_64 = { class: "table-wrapper" };
const _hoisted_65 = { class: "detail-table" };
const _hoisted_66 = { class: "nowrap" };
const _hoisted_67 = ["href"];
const _hoisted_68 = {
    key: 1,
    class: "run-time"
};
const _hoisted_69 = ["href"];
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart, BarChart, HeatmapChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, CalendarComponent, VisualMapComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import { useGitHistory } from '@/composables/useGitHistory';
import CiStatusIcon from '@/admin/components/CiStatusIcon.vue';
import { useChat } from '@/composables/useChat';
import { useAuth } from '@/composables/useAuth';
const BRAND = '#332847';
// Vibrant cool→warm heat scale for the activity calendar (low → high commits)
const POLL_MS = 15000;
// AI summary state
export default /*@__PURE__*/ _defineComponent({
    __name: 'GitHistoryPage',
    setup(__props) {
        use([CanvasRenderer, LineChart, BarChart, HeatmapChart, GridComponent, TooltipComponent, CalendarComponent, VisualMapComponent]);
        const HEAT = ['#EAF2F8', '#A8E6CF', '#FFD54F', '#FF8A65', '#E53935'];
        const { commits, loading, error, truncated, authError, hasToken, setToken, clearToken, fetchCommits, fetchCommitsForPath, fetchCommitsForBranches, fetchBranches, fetchWorkflowRuns, REPO, BRANCH } = useGitHistory();
        useAuth(); // initialise API config from route meta
        const { sendSessionlessChatMessage } = useChat();
        const tokenInput = ref('');
        const startDate = ref('');
        const endDate = ref('');
        const filterText = ref('');
        // per-area commits for the breakdown heatmaps
        const sitesCommits = ref([]);
        const servicesCommits = ref([]);
        // GitHub Actions runs (single fetch drives both the panel and the commit badges)
        const runs = ref([]);
        const runsLoading = ref(false);
        const autoRefresh = ref(true);
        const actionsOpen = ref(false);
        let runsPoll = null;
        const summary = ref('');
        const summaryActionsOpen = ref(false);
        const summaryLoading = ref(false);
        const summaryError = ref('');
        const copied = ref(false);
        // Branch picker — drives the summary fetch only (the rest of the page stays on dev)
        const branchOptions = ref([]);
        const selectedBranches = ref([BRANCH]);
        // Commits the last summary was generated from (fetched per scope + branches)
        const summaryCommits = ref([]);
        // --- date helpers -------------------------------------------------
        function toInputDate(d) {
            return d.toISOString().substring(0, 10);
        }
        // Which preset button drove the current range ('' = custom dates typed manually)
        const activePreset = ref('');
        function applyPreset(days) {
            activePreset.value = String(days);
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - days);
            startDate.value = toInputDate(start);
            endDate.value = toInputDate(end);
            load();
        }
        // Single-day presets: Today (0) / Yesterday (1)
        function applyDay(daysAgo) {
            activePreset.value = daysAgo === 0 ? 'today' : 'yesterday';
            const day = new Date();
            day.setDate(day.getDate() - daysAgo);
            startDate.value = toInputDate(day);
            endDate.value = toInputDate(day);
            load();
        }
        // Manually edited dates are a custom range — no preset is highlighted
        function onDateChange() {
            activePreset.value = '';
            load();
        }
        function saveToken() {
            if (!tokenInput.value.trim())
                return;
            setToken(tokenInput.value);
            tokenInput.value = '';
            load();
            loadBranches();
        }
        async function load() {
            if (!hasToken.value || !startDate.value || !endDate.value)
                return;
            const opts = {
                since: new Date(startDate.value + 'T00:00:00Z').toISOString(),
                until: new Date(endDate.value + 'T23:59:59Z').toISOString()
            };
            fetchCommits(opts); // whole repo → drives every main view + the Overall heatmap
            // area breakdowns for the Sites / Services heatmaps
            sitesCommits.value = [];
            servicesCommits.value = [];
            const [sites, services] = await Promise.all([
                fetchCommitsForPath(opts, 'Sites'),
                fetchCommitsForPath(opts, 'Services')
            ]);
            sitesCommits.value = sites;
            servicesCommits.value = services;
            loadRuns();
        }
        async function loadRuns() {
            if (!hasToken.value)
                return;
            runsLoading.value = true;
            runs.value = await fetchWorkflowRuns();
            runsLoading.value = false;
        }
        // Auto-refresh: poll every POLL_MS while the tickbox is on, stop when off.
        function syncPolling() {
            if (autoRefresh.value && !runsPoll) {
                runsPoll = setInterval(loadRuns, POLL_MS);
            }
            else if (!autoRefresh.value && runsPoll) {
                clearInterval(runsPoll);
                runsPoll = null;
            }
        }
        watch(autoRefresh, syncPolling);
        function formatDate(iso) {
            if (!iso)
                return '';
            return new Date(iso).toLocaleString('en-GB', {
                day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
            });
        }
        function relativeTime(iso) {
            if (!iso)
                return '';
            const diff = Date.now() - new Date(iso).getTime();
            const mins = Math.round(diff / 60000);
            if (mins < 1)
                return 'just now';
            if (mins < 60)
                return `${mins}m ago`;
            const hrs = Math.round(mins / 60);
            if (hrs < 24)
                return `${hrs}h ago`;
            const days = Math.round(hrs / 24);
            return `${days}d ago`;
        }
        // --- GitHub Actions -----------------------------------------------
        // One run per sha for badges — runs come newest-first, so the first wins.
        const runBySha = computed(() => {
            const map = new Map();
            for (const r of runs.value) {
                if (r.headSha && !map.has(r.headSha))
                    map.set(r.headSha, r);
            }
            return map;
        });
        const runningRuns = computed(() => runs.value.filter(r => r.status === 'in_progress' || r.status === 'queued'));
        const recentRuns = computed(() => runs.value.filter(r => r.status === 'completed').slice(0, 10));
        // Maps a run to a pill variant (drives the CSS colour) + readable label.
        function runDisplay(run) {
            if (run.status === 'in_progress')
                return { variant: 'running', label: 'Running' };
            if (run.status === 'queued')
                return { variant: 'running', label: 'Queued' };
            if (run.conclusion === 'success')
                return { variant: 'success', label: 'Passed' };
            if (run.conclusion === 'failure')
                return { variant: 'fail', label: 'Failed' };
            return { variant: 'neutral', label: run.conclusion || run.status };
        }
        // --- derived data -------------------------------------------------
        const filteredCommits = computed(() => {
            const q = filterText.value.trim().toLowerCase();
            if (!q)
                return commits.value;
            return commits.value.filter(c => c.message.toLowerCase().includes(q) ||
                c.author.toLowerCase().includes(q) ||
                c.sha.toLowerCase().includes(q));
        });
        // commit count per day (YYYY-MM-DD)
        function countsFrom(list) {
            const map = new Map();
            for (const c of list) {
                if (!c.date)
                    continue;
                const day = c.date.substring(0, 10);
                map.set(day, (map.get(day) || 0) + 1);
            }
            return map;
        }
        const countsByDay = computed(() => countsFrom(commits.value));
        const sitesCounts = computed(() => countsFrom(sitesCommits.value));
        const servicesCounts = computed(() => countsFrom(servicesCommits.value));
        const activeDays = computed(() => countsByDay.value.size);
        // every day in the selected range, ascending — keeps the line continuous.
        // A single-day range switches to an hourly breakdown of that day instead.
        const overTimeOption = computed(() => {
            const labels = [];
            const values = [];
            const singleDay = !!startDate.value && startDate.value === endDate.value;
            if (singleDay) {
                for (let h = 0; h < 24; h++) {
                    labels.push(`${String(h).padStart(2, '0')}:00`);
                    values.push(0);
                }
                for (const c of commits.value) {
                    if (c.date)
                        values[new Date(c.date).getHours()]++;
                }
            }
            else if (startDate.value && endDate.value) {
                const cur = new Date(startDate.value + 'T00:00:00Z');
                const end = new Date(endDate.value + 'T00:00:00Z');
                while (cur <= end) {
                    const day = toInputDate(cur);
                    labels.push(day);
                    values.push(countsByDay.value.get(day) || 0);
                    cur.setDate(cur.getDate() + 1);
                }
            }
            return {
                tooltip: { trigger: 'axis' },
                grid: { left: 40, right: 20, top: 20, bottom: 40 },
                xAxis: { type: 'category', data: labels, axisLabel: { hideOverlap: true } },
                yAxis: { type: 'value', minInterval: 1 },
                series: [{
                        type: 'line',
                        data: values,
                        smooth: true,
                        showSymbol: false,
                        areaStyle: { opacity: 0.15, color: BRAND },
                        lineStyle: { color: BRAND },
                        itemStyle: { color: BRAND }
                    }]
            };
        });
        const authorRows = computed(() => {
            const map = new Map();
            for (const c of commits.value) {
                map.set(c.author, (map.get(c.author) || 0) + 1);
            }
            const total = commits.value.length || 1;
            return Array.from(map.entries())
                .map(([author, count]) => ({ author, count, share: Math.round((count / total) * 100) }))
                .sort((a, b) => b.count - a.count);
        });
        const authorChartHeight = computed(() => Math.max(200, authorRows.value.length * 30 + 60));
        const authorOption = computed(() => {
            // horizontal bars, highest at the top
            const rows = [...authorRows.value].reverse();
            return {
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                grid: { left: 140, right: 30, top: 10, bottom: 30 },
                xAxis: { type: 'value', minInterval: 1 },
                yAxis: { type: 'category', data: rows.map(r => r.author) },
                series: [{
                        type: 'bar',
                        data: rows.map(r => r.count),
                        itemStyle: { color: BRAND, borderRadius: [0, 4, 4, 0] }
                    }]
            };
        });
        // shared scale across all three heatmaps so areas are visually comparable
        const heatmapMax = computed(() => {
            let max = 1;
            for (const v of countsByDay.value.values())
                max = Math.max(max, v);
            return max;
        });
        function buildHeatmapOption(counts) {
            const data = Array.from(counts.entries()).map(([day, count]) => [day, count]);
            return {
                tooltip: { formatter: (p) => `${p.value[0]}: ${p.value[1]} commit${p.value[1] === 1 ? '' : 's'}` },
                visualMap: {
                    min: 0,
                    max: heatmapMax.value,
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    bottom: 0,
                    inRange: { color: HEAT }
                },
                calendar: {
                    range: [startDate.value, endDate.value],
                    cellSize: ['auto', 16],
                    top: 35,
                    bottom: 50,
                    left: 30,
                    right: 10,
                    itemStyle: { borderWidth: 2, borderColor: '#fff' },
                    monthLabel: { margin: 8 },
                    yearLabel: { show: true }
                },
                series: [{ type: 'heatmap', coordinateSystem: 'calendar', data }]
            };
        }
        const overallHeatmap = computed(() => buildHeatmapOption(countsByDay.value));
        const sitesHeatmap = computed(() => buildHeatmapOption(sitesCounts.value));
        const servicesHeatmap = computed(() => buildHeatmapOption(servicesCounts.value));
        // --- AI summary (follows the page's From/To date filter) ----
        // A single-day range produces a standup-style update; a longer range
        // produces the upbeat platform update.
        const summarySingleDay = computed(() => !!startDate.value && startDate.value === endDate.value);
        const summaryRangeLabel = computed(() => {
            if (!startDate.value || !endDate.value)
                return '';
            if (summarySingleDay.value) {
                return new Date(startDate.value + 'T00:00:00').toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
            }
            const fmt = (d) => new Date(d + 'T00:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
            return `${fmt(startDate.value)} – ${fmt(endDate.value)}`;
        });
        const branchLabel = computed(() => (selectedBranches.value.length ? selectedBranches.value : [BRANCH]).join(', '));
        const summaryStats = computed(() => {
            const authorMap = new Map();
            const dayset = new Set();
            for (const c of summaryCommits.value) {
                authorMap.set(c.author, (authorMap.get(c.author) || 0) + 1);
                if (c.date)
                    dayset.add(c.date.substring(0, 10));
            }
            const authors = Array.from(authorMap.entries())
                .map(([author, count]) => ({ author, count }))
                .sort((a, b) => b.count - a.count);
            return {
                count: summaryCommits.value.length,
                contributors: authors.length,
                activeDays: dayset.size,
                topAuthors: authors.slice(0, 5).map(a => `${a.author} (${a.count})`).join(', ')
            };
        });
        async function generateSummary() {
            if (!startDate.value || !endDate.value)
                return;
            const branches = selectedBranches.value.length ? selectedBranches.value : [BRANCH];
            summaryLoading.value = true;
            summaryError.value = '';
            summary.value = '';
            // Fetch commits for the page's filter range across every selected branch.
            const list = await fetchCommitsForBranches({
                since: new Date(startDate.value + 'T00:00:00Z').toISOString(),
                until: new Date(endDate.value + 'T23:59:59Z').toISOString()
            }, branches);
            summaryCommits.value = list;
            if (list.length === 0) {
                summaryLoading.value = false;
                summaryError.value = `No commits on ${branchLabel.value} for ${summaryRangeLabel.value}.`;
                return;
            }
            const messages = list.slice(0, 200).map(c => `- ${c.message} (${c.author})`).join('\n');
            const prompt = summarySingleDay.value
                ? `You are summarising git activity for a developer standup.\n` +
                    `Below are the commit messages from branch(es) ${branchLabel.value} for ${summaryRangeLabel.value}.\n` +
                    `Write a concise, factual standup update of what was done, grouped by contributor. ` +
                    `Use markdown: a short bullet list per person. Keep it tight and skimmable — this is read out in a standup. ` +
                    `Only use information present in the commit messages — do not invent work that isn't listed. ` +
                    `Open with a one-line headline mentioning ${summaryStats.value.count} commits from ${summaryStats.value.contributors} contributors.\n\n` +
                    `Commit messages:\n${messages}`
                : `You are writing an internal company update for a non-technical audience.\n` +
                    `Below are the git commit messages from branch(es) ${branchLabel.value} for ${summaryRangeLabel.value}.\n` +
                    `Write a short, upbeat summary of what the team shipped, grouped into themes ` +
                    `(for example: New features, Improvements, Fixes). Use markdown with a few relevant emoji as section headers and concise bullet points. ` +
                    `Be specific but only use information present in the commit messages — do not invent work that isn't listed. ` +
                    `Open with a one-line headline mentioning ${summaryStats.value.count} commits from ${summaryStats.value.contributors} contributors.\n\n` +
                    `Commit messages:\n${messages}`;
            // The Ex endpoint is fire-and-forget (no error path), so guard against a hung spinner.
            const watchdog = setTimeout(() => {
                if (summaryLoading.value) {
                    summaryLoading.value = false;
                    summaryError.value = 'No response from the AI — please try again.';
                }
            }, 90000);
            sendSessionlessChatMessage(prompt, (result) => {
                clearTimeout(watchdog);
                summary.value = result?.body || '';
                summaryLoading.value = false;
            });
        }
        const summaryMarkdown = computed(() => {
            const s = summaryStats.value;
            const title = summarySingleDay.value ? 'Standup update' : 'Team update';
            const header = `## ${title} — ${summaryRangeLabel.value}\n` +
                `**${s.count} commits · ${s.contributors} contributors · ${s.activeDays} active days · ${branchLabel.value}**\n\n` +
                (s.topAuthors ? `Top contributors: ${s.topAuthors}\n\n` : '');
            return header + summary.value;
        });
        async function copySummary() {
            try {
                await navigator.clipboard.writeText(summaryMarkdown.value);
                copied.value = true;
                setTimeout(() => { copied.value = false; }, 2000);
            }
            catch {
                summaryError.value = 'Could not copy to clipboard.';
            }
        }
        // Populate the summary branch picker with branches active in the last 7 days
        // (dev always kept, listed first, then alphabetical).
        async function loadBranches() {
            if (!hasToken.value)
                return;
            const since = new Date();
            since.setDate(since.getDate() - 7);
            const names = await fetchBranches(since.toISOString());
            if (!names.includes(BRANCH))
                names.push(BRANCH); // keep the default usable even if quiet
            names.sort((a, b) => (a === BRANCH ? -1 : b === BRANCH ? 1 : a.localeCompare(b)));
            branchOptions.value = names;
        }
        // --- init ---------------------------------------------------------
        onMounted(() => {
            applyDay(0); // default to Today
            syncPolling();
            loadBranches();
        });
        onUnmounted(() => {
            if (runsPoll)
                clearInterval(runsPoll);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[15] || (_cache[15] = _createElementVNode("h1", null, "Git History", -1)),
                    _createElementVNode("p", _hoisted_3, "Commit activity for " + _toDisplayString(_unref(REPO)), 1)
                ]),
                (!_unref(hasToken) || _unref(authError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[16] || (_cache[16] = _createElementVNode("h4", null, "GitHub access token required", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "subtitle" }, [
                            _createTextVNode(" This repo is private, so a personal access token with "),
                            _createElementVNode("strong", null, "repo"),
                            _createTextVNode(" scope is needed. It is stored only in this browser and never sent anywhere except GitHub. "),
                            _createElementVNode("a", {
                                href: "https://github.com/settings/tokens/new?scopes=repo&description=Syso%20Admin%20Git%20History",
                                target: "_blank",
                                rel: "noopener"
                            }, "Create one →")
                        ], -1)),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tokenInput).value = $event)),
                                type: "password",
                                class: "form-input",
                                placeholder: "ghp_...",
                                onKeyup: _withKeys(saveToken, ["enter"])
                            }, null, 544), [
                                [_vModelText, tokenInput.value]
                            ]),
                            _createElementVNode("button", {
                                class: "action-btn primary",
                                disabled: !tokenInput.value.trim(),
                                onClick: saveToken
                            }, "Save token", 8, _hoisted_6)
                        ]),
                        (_unref(error))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(error)), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[18] || (_cache[18] = _createElementVNode("label", null, "From", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((startDate).value = $event)),
                                    type: "date",
                                    class: "form-input",
                                    onChange: onDateChange
                                }, null, 544), [
                                    [_vModelText, startDate.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", null, "To", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((endDate).value = $event)),
                                    type: "date",
                                    class: "form-input",
                                    onChange: onDateChange
                                }, null, 544), [
                                    [_vModelText, endDate.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === 'today' ? 'primary' : 'secondary']),
                                    onClick: _cache[3] || (_cache[3] = ($event) => (applyDay(0)))
                                }, "Today", 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === 'yesterday' ? 'primary' : 'secondary']),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (applyDay(1)))
                                }, "Yesterday", 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === '7' ? 'primary' : 'secondary']),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (applyPreset(7)))
                                }, "7d", 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === '30' ? 'primary' : 'secondary']),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (applyPreset(30)))
                                }, "30d", 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === '90' ? 'primary' : 'secondary']),
                                    onClick: _cache[7] || (_cache[7] = ($event) => (applyPreset(90)))
                                }, "90d", 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn", activePreset.value === '365' ? 'primary' : 'secondary']),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (applyPreset(365)))
                                }, "1y", 2)
                            ]),
                            _createElementVNode("button", {
                                class: "action-btn secondary change-token",
                                onClick: _cache[9] || (_cache[9] =
                                    //@ts-ignore
                                    (...args) => (_unref(clearToken) && _unref(clearToken)(...args)))
                            }, "Change token")
                        ]),
                        (_unref(loading))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[20] || (_cache[20] = [
                                _createElementVNode("div", { class: "spinner" }, null, -1),
                                _createElementVNode("p", null, "Loading commits from GitHub…", -1)
                            ])))
                            : (_unref(error))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(error)), 1))
                                : (_unref(commits).length === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "No commits found in this date range."))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                        (_unref(truncated))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, " ⚠️ Showing the first " + _toDisplayString(_unref(commits).length) + " commits — the range exceeds the fetch limit. Narrow the dates for a complete picture. ", 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(commits).length), 1),
                                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "summary-label" }, "Commits", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("span", _hoisted_20, _toDisplayString(authorRows.value.length), 1),
                                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "summary-label" }, "Contributors", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("span", _hoisted_22, _toDisplayString(activeDays.value), 1),
                                                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "summary-label" }, "Active days", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("button", {
                                                    class: "summary-toggle",
                                                    onClick: _cache[10] || (_cache[10] = ($event) => (actionsOpen.value = !actionsOpen.value))
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["summary-caret", { open: actionsOpen.value }])
                                                    }, "▸", 2),
                                                    _cache[24] || (_cache[24] = _createElementVNode("h4", null, "GitHub Actions", -1))
                                                ]),
                                                _withDirectives(_createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("label", _hoisted_26, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((autoRefresh).value = $event)),
                                                            type: "checkbox"
                                                        }, null, 512), [
                                                            [_vModelCheckbox, autoRefresh.value]
                                                        ]),
                                                        _cache[25] || (_cache[25] = _createTextVNode(" Auto-refresh "))
                                                    ]),
                                                    _createElementVNode("button", {
                                                        class: "action-btn secondary",
                                                        disabled: runsLoading.value,
                                                        onClick: loadRuns
                                                    }, _toDisplayString(runsLoading.value ? 'Refreshing…' : 'Refresh'), 9, _hoisted_27)
                                                ], 512), [
                                                    [_vShow, actionsOpen.value]
                                                ])
                                            ]),
                                            (actionsOpen.value)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("p", _hoisted_28, [
                                                        _cache[26] || (_cache[26] = _createTextVNode(" Latest workflow runs on ")),
                                                        _createElementVNode("strong", null, _toDisplayString(_unref(BRANCH)), 1),
                                                        _cache[27] || (_cache[27] = _createTextVNode(". ")),
                                                        (runningRuns.value.length)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Auto-refreshing while runs are active."))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("h5", _hoisted_30, "Running (" + _toDisplayString(runningRuns.value.length) + ")", 1),
                                                    (runningRuns.value.length === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, "Nothing running right now."))
                                                        : (_openBlock(), _createElementBlock("ul", _hoisted_32, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningRuns.value, (run) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                    key: run.id,
                                                                    class: "run-row"
                                                                }, [
                                                                    _createVNode(CiStatusIcon, {
                                                                        variant: runDisplay(run).variant,
                                                                        label: runDisplay(run).label
                                                                    }, null, 8, ["variant", "label"]),
                                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(run.name), 1),
                                                                    _createElementVNode("a", {
                                                                        href: `https://github.com/${_unref(REPO)}/commit/${run.headSha}`,
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        class: "sha-link"
                                                                    }, _toDisplayString(run.headShaShort), 9, _hoisted_34),
                                                                    _createElementVNode("span", _hoisted_35, _toDisplayString(relativeTime(run.createdAt)), 1),
                                                                    _createElementVNode("a", {
                                                                        href: run.htmlUrl,
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        class: "run-link"
                                                                    }, "View →", 8, _hoisted_36)
                                                                ]));
                                                            }), 128))
                                                        ])),
                                                    _cache[28] || (_cache[28] = _createElementVNode("h5", { class: "heatmap-label" }, "Recently completed", -1)),
                                                    (recentRuns.value.length === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, "No completed runs in range."))
                                                        : (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentRuns.value, (run) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                    key: run.id,
                                                                    class: "run-row"
                                                                }, [
                                                                    _createVNode(CiStatusIcon, {
                                                                        variant: runDisplay(run).variant,
                                                                        label: runDisplay(run).label
                                                                    }, null, 8, ["variant", "label"]),
                                                                    _createElementVNode("span", _hoisted_39, _toDisplayString(run.name), 1),
                                                                    _createElementVNode("a", {
                                                                        href: `https://github.com/${_unref(REPO)}/commit/${run.headSha}`,
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        class: "sha-link"
                                                                    }, _toDisplayString(run.headShaShort), 9, _hoisted_40),
                                                                    _createElementVNode("span", _hoisted_41, _toDisplayString(relativeTime(run.updatedAt)), 1),
                                                                    _createElementVNode("a", {
                                                                        href: run.htmlUrl,
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        class: "run-link"
                                                                    }, "View →", 8, _hoisted_42)
                                                                ]));
                                                            }), 128))
                                                        ]))
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("button", {
                                                    class: "summary-toggle",
                                                    onClick: _cache[12] || (_cache[12] = ($event) => (summaryActionsOpen.value = !summaryActionsOpen.value))
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(["summary-caret", { open: summaryActionsOpen.value }])
                                                    }, "▸", 2),
                                                    _cache[29] || (_cache[29] = _createElementVNode("h4", null, "AI summary", -1))
                                                ]),
                                                _withDirectives(_createElementVNode("div", _hoisted_45, [
                                                    _createElementVNode("button", {
                                                        class: "action-btn primary",
                                                        disabled: summaryLoading.value,
                                                        onClick: generateSummary
                                                    }, _toDisplayString(summaryLoading.value ? 'Generating…' : (summary.value ? 'Regenerate' : 'Generate AI summary')), 9, _hoisted_46),
                                                    (summary.value)
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "action-btn secondary",
                                                            onClick: copySummary
                                                        }, _toDisplayString(copied.value ? 'Copied!' : 'Copy as markdown'), 1))
                                                        : _createCommentVNode("", true)
                                                ], 512), [
                                                    [_vShow, summaryActionsOpen.value]
                                                ])
                                            ]),
                                            _withDirectives(_createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("div", _hoisted_48, [
                                                    _cache[30] || (_cache[30] = _createElementVNode("label", null, [
                                                        _createTextVNode("Branches "),
                                                        _createElementVNode("span", { class: "branch-hint" }, "(active in last 7 days · Ctrl/Cmd-click for multiple)")
                                                    ], -1)),
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((selectedBranches).value = $event)),
                                                        multiple: "",
                                                        class: "form-input branch-select",
                                                        size: "5"
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchOptions.value, (b) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: b,
                                                                value: b
                                                            }, _toDisplayString(b), 9, _hoisted_49));
                                                        }), 128))
                                                    ], 512), [
                                                        [_vModelSelect, selectedBranches.value]
                                                    ])
                                                ])
                                            ], 512), [
                                                [_vShow, summaryActionsOpen.value]
                                            ]),
                                            _createElementVNode("p", _hoisted_50, [
                                                _createTextVNode("AI-written summary for " + _toDisplayString(summaryRangeLabel.value) + " on ", 1),
                                                _createElementVNode("strong", null, _toDisplayString(branchLabel.value), 1),
                                                _cache[31] || (_cache[31] = _createTextVNode(" — review before sharing."))
                                            ]),
                                            (summaryError.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(summaryError.value), 1))
                                                : _createCommentVNode("", true),
                                            (summaryLoading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, _cache[32] || (_cache[32] = [
                                                    _createElementVNode("div", { class: "spinner" }, null, -1),
                                                    _createElementVNode("p", null, "Asking the AI…", -1)
                                                ])))
                                                : (summary.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(summary.value), 1))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                            _cache[33] || (_cache[33] = _createElementVNode("h4", null, "Commits over time", -1)),
                                            _createVNode(_unref(VChart), {
                                                class: "chart",
                                                option: overTimeOption.value,
                                                autoresize: ""
                                            }, null, 8, ["option"])
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                            _cache[34] || (_cache[34] = _createElementVNode("h4", null, "Activity heatmaps", -1)),
                                            _cache[35] || (_cache[35] = _createElementVNode("p", { class: "subtitle" }, "Daily commit density, shared colour scale across all three areas.", -1)),
                                            _createElementVNode("h5", _hoisted_56, "Overall (" + _toDisplayString(_unref(commits).length) + ")", 1),
                                            _createVNode(_unref(VChart), {
                                                class: "heatmap-chart",
                                                option: overallHeatmap.value,
                                                autoresize: ""
                                            }, null, 8, ["option"]),
                                            _createElementVNode("h5", _hoisted_57, "Sites (" + _toDisplayString(sitesCommits.value.length) + ")", 1),
                                            _createVNode(_unref(VChart), {
                                                class: "heatmap-chart",
                                                option: sitesHeatmap.value,
                                                autoresize: ""
                                            }, null, 8, ["option"]),
                                            _createElementVNode("h5", _hoisted_58, "Services (" + _toDisplayString(servicesCommits.value.length) + ")", 1),
                                            _createVNode(_unref(VChart), {
                                                class: "heatmap-chart",
                                                option: servicesHeatmap.value,
                                                autoresize: ""
                                            }, null, 8, ["option"])
                                        ]),
                                        _createElementVNode("div", _hoisted_59, [
                                            _cache[37] || (_cache[37] = _createElementVNode("h4", null, "By author", -1)),
                                            _createVNode(_unref(VChart), {
                                                class: "chart",
                                                option: authorOption.value,
                                                autoresize: "",
                                                style: _normalizeStyle({ height: authorChartHeight.value + 'px' })
                                            }, null, 8, ["option", "style"]),
                                            _createElementVNode("div", _hoisted_60, [
                                                _createElementVNode("table", _hoisted_61, [
                                                    _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "Author"),
                                                            _createElementVNode("th", null, "Commits"),
                                                            _createElementVNode("th", null, "Share")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(authorRows.value, (row) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: row.author
                                                            }, [
                                                                _createElementVNode("td", null, _toDisplayString(row.author), 1),
                                                                _createElementVNode("td", null, _toDisplayString(row.count), 1),
                                                                _createElementVNode("td", null, _toDisplayString(row.share) + "%", 1)
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("h4", null, "Commits (" + _toDisplayString(filteredCommits.value.length) + ")", 1),
                                            _createElementVNode("div", _hoisted_63, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((filterText).value = $event)),
                                                    type: "text",
                                                    class: "search-input",
                                                    placeholder: "Filter by message, author or sha…"
                                                }, null, 512), [
                                                    [_vModelText, filterText.value]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_64, [
                                                _createElementVNode("table", _hoisted_65, [
                                                    _cache[38] || (_cache[38] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "Date"),
                                                            _createElementVNode("th", null, "Author"),
                                                            _createElementVNode("th", null, "Message"),
                                                            _createElementVNode("th", null, "CI"),
                                                            _createElementVNode("th", null, "SHA")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCommits.value, (c) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: c.sha
                                                            }, [
                                                                _createElementVNode("td", _hoisted_66, _toDisplayString(formatDate(c.date)), 1),
                                                                _createElementVNode("td", null, _toDisplayString(c.author), 1),
                                                                _createElementVNode("td", null, _toDisplayString(c.message), 1),
                                                                _createElementVNode("td", null, [
                                                                    (runBySha.value.get(c.sha))
                                                                        ? (_openBlock(), _createElementBlock("a", {
                                                                            key: 0,
                                                                            href: runBySha.value.get(c.sha).htmlUrl,
                                                                            target: "_blank",
                                                                            rel: "noopener",
                                                                            class: "ci-cell"
                                                                        }, [
                                                                            _createVNode(CiStatusIcon, {
                                                                                variant: runDisplay(runBySha.value.get(c.sha)).variant,
                                                                                label: runDisplay(runBySha.value.get(c.sha)).label
                                                                            }, null, 8, ["variant", "label"])
                                                                        ], 8, _hoisted_67))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_68, "—"))
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _createElementVNode("a", {
                                                                        href: `https://github.com/${_unref(REPO)}/commit/${c.sha}`,
                                                                        target: "_blank",
                                                                        rel: "noopener",
                                                                        class: "sha-link"
                                                                    }, _toDisplayString(c.shortSha), 9, _hoisted_69)
                                                                ])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ], 64))
                    ], 64))
            ]));
        };
    }
});
